import { createAction } from '@reduxjs/toolkit';

export const navigateTo = createAction<string>('stylovyze/navigate');
export const navigateToResolved = createAction('stylovyze/navigate/resolved');
export const navigateToReject = createAction('stylovyze/navigate/reject');
